import axios from "axios";

import appSettings from "../../../../config/config";
const apiUrl = appSettings.apiUrl

const updateBusinessToPremium = async (
  wlAccountId,
  businessDetails,
  period,
  discountCode,
  notes
) => {
  try {
    await axios.post(
      `${apiUrl}/api/v1/partner/portal/wl/${wlAccountId}/business/${businessDetails.id}/subscribe`,
      {
        pricingSegmentId: businessDetails.pricingSegmentId,
        period: period,
        discountCode,
        eventData: {
          "businessId": businessDetails.id,
          "notes": notes,
        }
      }
    );
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

const createFreeTrialExtension = async (wlAccountId, businessId, numberOfDays, notes) => {
  try {
    await axios.post(
      `${apiUrl}/api/v1/partner/portal/wl/${wlAccountId}/business/${businessId}/extendFreeTrial`,
      {
        freeTrialDays: numberOfDays,
        eventData: {
          "businessId": businessId,
          "notes": notes,
        }
      }
    );
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

const blockBusiness = async (wlAccountId, businessId, notes) => {
  try {
    await axios.post(`${apiUrl}/api/v1/partner/portal/wl/${wlAccountId}/business/${businessId}/block`, {
      eventData: {
        "businessId": businessId,
        "notes": notes,
      }
    });
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

const unblockBusiness = async (wlAccountId, businessId, notes) => {
  try {
    await axios.post(`${apiUrl}/api/v1/partner/portal/wl/${wlAccountId}/business/${businessId}/unblock`, {
      eventData: {
        "businessId": businessId,
        "notes": notes,
      }
    });
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

const getWhitelabelBusinesses = async ({ wlId, bId, options }) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/v1/partner/portal/wl/${wlId}/businesses/`,
      {
        params: {
          bId,
          options
        }
      }
    );
    return response.data.businesses || [];
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

const getWhitelabelBusinessesByEmail = async (email, wlId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/v1/partner/portal/wl/${wlId}/getBusinessesByEmail?email=${email}`
    );
    return response.data.businesses || [];
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

const getWhitelabelBusinessesCount = async (wlId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/v1/partner/portal/wl/${wlId}/businesses/count`
    );
    return response.data || 0;
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

const getAllWhitelabelBusinesses = async (wlId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/v1/partner/portal/wl/${wlId}/allBusinesses`
    );
    return response.data.businesses || [];
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

export default {
  updateBusinessToPremium,
  createFreeTrialExtension,
  blockBusiness,
  unblockBusiness,
  getWhitelabelBusinesses,
  getWhitelabelBusinessesByEmail,
  getWhitelabelBusinessesCount,
  getAllWhitelabelBusinesses
};
